import { FC } from 'react'

import { ApplicationClock } from '@components/ApplicationClock'
import { URLPathControl } from '@components/URLPathControl'

import { ActiveClinicSwitcher } from '@modules/active-clinic/components/ActiveClinicSwitcher/ActiveClinicSwitcher'
import { HasActiveClinic } from '@modules/active-clinic/components/HasActiveClinic'
import { NotificationTopbar } from '@modules/notification/components/NotificationTopbar'
import { PermissionsControl } from '@modules/permissions'
import { QueueTopbarMenu } from '@modules/queues/components/QueueTopbarMenu'
import { TaskListTopbar } from '@modules/tasks/components/TaskListTopbar'

import { PermissionEnum } from '@/constants/permission'

const HeaderToolbar: FC = () => (
  <div
    className="d-flex flex-shrink-0"
    id="end-topbar"
  >
    {/* begin::back-to-patient */}
    {/* the component will be portaled to this place */}
    <div
      className="d-flex align-items-center ms-3"
      id="back-to-active-medical-record-container"
    />
    {/* end::back-to-patient */}

    {/* begin::Application Time */}
    <div className="d-flex align-items-center ms-3">
      <ApplicationClock />
    </div>
    {/* end::Application TIime */}

    {/* begin::Active Clinic */}
    <URLPathControl blockedPath={['/medical-record']}>
      <HasActiveClinic>
        <div className="d-flex align-items-center ms-3">
          <ActiveClinicSwitcher />
        </div>
      </HasActiveClinic>
    </URLPathControl>
    {/* end::Active Clinic */}

    {/* begin::Queue */}
    <PermissionsControl allow={[PermissionEnum.QUEUE_SHOW_PROCESS]}>
      <div className="d-flex align-items-center ms-3">
        <QueueTopbarMenu />
      </div>
    </PermissionsControl>
    {/* end::Queue */}

    {/* begin::Tasks */}
    <PermissionsControl allow={[PermissionEnum.TASK_LIST, PermissionEnum.TASK_UPDATE]}>
      <div className="d-flex align-items-center ms-3">
        <TaskListTopbar />
      </div>
    </PermissionsControl>
    {/* end::Tasks */}

    {/* begin::Notification */}
    <div className="d-flex align-items-center ms-3">
      <NotificationTopbar />
    </div>
    {/* end::Notification */}

    {/* begin::Past Patient */}
    {/* the component will be portaled to this place */}
    <div
      className="d-flex align-items-center ms-3"
      id="past-patient-container"
    />
    {/* end::Past Patient */}
  </div>
)

export { HeaderToolbar }
